<template>
    <v-container align-start>
        <v-form
            class="form-phone"
            v-model="valid"
            ref="form"
            @submit.native.prevent="next"
        >
            <v-layout>
                <p v-if="isVerification">
                    {{ lang.phone_binding_text }}{{ bindingValue }}
                </p>
                <v-flex xs12 v-else>
                    <v-text-field
                        v-model="pCode"
                        solo
                        :label="lang.security_phone_label"
                        :readonly="sending"
                        :disabled="pageLoading"
                        class="input-phone-number"
                        :rules="rules"
                    >
                        <v-btn
                            color="info"
                            class="ma-0 mr-2 btn-h48"
                            slot="prepend"
                            @click="showEditAreaCodeSheet"
                        >
                            <v-icon v-if="isAreaCodeCanEdit && !sending">
                                fas fa-pen
                            </v-icon>
                            {{ aCode ? "+" + aCode : "" }}
                        </v-btn>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <verification-code
                v-model="vCode"
                :params="{ mobile: fullPhoneNumber }"
                :error="isErrCode"
                :stop="isCountDownStop"
                :disabled="
                    (!isPhoneNumberValid || isErrValue) && !isVerification
                "
                @send="v => (sending = v)"
            ></verification-code>
            <v-btn
                block
                :disabled="!valid"
                class="btn-h48"
                color="primary"
                @click="next"
            >
                {{ buttonText }}
            </v-btn>
            <v-btn
                class="ma-0 right"
                color="primary"
                flat
                small
                @click="choseVType"
                v-if="isVerification && isOtherVerificationTypeShow"
            >
                {{ lang.use_other_verification_type_text }}
            </v-btn>
        </v-form>
        <v-bottom-sheet v-model="bottomSheetVisible">
            <v-card class="phone-bottom-card">
                <v-list>
                    <template v-for="(item, index) in areaCodes">
                        <v-divider
                            :key="'divider' + index"
                            v-if="index > 0"
                        ></v-divider>
                        <v-list-tile
                            :key="item.code + '-' + index"
                            @click="selectCode(item.code)"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.name }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-list-tile-action-text>
                                    +{{ item.code }}
                                </v-list-tile-action-text>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-card>
        </v-bottom-sheet>
        <q-dialog
            :visible.sync="dialogVisible"
            active="mobile"
            v-if="isOtherVerificationTypeShow"
        ></q-dialog>
        <v-dialog v-model="alertVisible">
            <v-card :color="alertType" dark>
                <v-card-text>
                    <v-layout align-center>
                        <span>{{ lang["submit_" + alertType + "_tips"] }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            fab
                            small
                            light
                            @click="alertVisible = false"
                        >
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { parsePhoneNumberFromString } from "libphonenumber-js/mobile";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import VerificationCode from "@/components/VerificationCode";
import QDialog from "@/components/QDialog";

let defaultAreaCodes = {
    ar: 971,
    es: 54,
    de: 49,
    el: 30,
    en: 61,
    fr: 33,
    he: 972,
    it: 39,
    nl: 31,
    pl: 48,
    pt: 55,
    ru: 375,
    sv: 46,
    tr: 90,
    zh: 86,
    tw: 86,
    ja: 81,
    ko: 82,
    th: 66,
    vi: 84
};

export default {
    name: "Mobile",
    components: {
        VerificationCode,
        QDialog
    },
    data() {
        return {
            alertVisible: false,
            alertType: "",
            bottomSheetVisible: false,
            dialogVisible: false,
            aCode: "",
            vCode: "",
            pCode: "",
            sending: false,
            valid: false,
            isErrValue: false,
            isErrCode: false,
            isCountDownStop: false
        };
    },
    computed: {
        ...mapState([
            "authVerifiedType",
            "pageLoading",
            "pageParent",
            "params"
        ]),
        ...mapGetters(["lang", "areaCodes", "securityObj", "settedSecurities"]),
        isOtherVerificationTypeShow() {
            return this.settedSecurities.length > 1;
        },
        bindingValue() {
            return this.securityObj.mobile.value;
        },
        isVerification() {
            return (
                !this.authVerifiedType ||
                this.authVerifiedType === "verification"
            );
        },
        buttonText() {
            return !this.isVerification
                ? this.lang.submit_text
                : this.lang.next_step_text;
        },
        isAreaCodeCanEdit() {
            return this.areaCodes.length > 1;
        },
        fullPhoneNumber() {
            return "+" + this.aCode + this.pCode;
        },
        isPhoneNumberValid() {
            let phoneNumber = parsePhoneNumberFromString(this.fullPhoneNumber);
            return phoneNumber && phoneNumber.isValid();
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_phone_number_tips);
            tmp.push(
                () =>
                    this.isPhoneNumberValid ||
                    this.lang.iscorrect_phone_number_tips
            );
            tmp.push(
                () => this.isErrValue && this.lang.iscorrect_phone_number_tips
            );
            return tmp;
        },
        action() {
            let tmp;
            if (this.isVerification) {
                tmp =
                    this.pageParent === "password"
                        ? this.verifyCodeFFTR
                        : this.verifyCodeFVS;
                return tmp;
            }
            switch (this.authVerifiedType) {
                case "password":
                    tmp = this.setSecurityFPTS;
                    break;
                case "email":
                    tmp = this.setSecurityFSTS;
                    break;
                case "mobile":
                    tmp = this.setSecurityFSTS;
                    break;
                case "question":
                    tmp = this.setSecurityFSTS;
                    break;
            }
            return tmp;
        }
    },
    watch: {
        pCode() {
            this.isErrValue = false;
        },
        vCode(val) {
            if (val) {
                this.isErrCode = false;
            }
        },
        alertVisible(val) {
            if (!val) {
                this.changeAuthVerified("");
                this.$router.push({
                    name: "security",
                    query: Object.assign({}, this.params, {
                        t: Date.now()
                    })
                });
            }
        }
    },
    methods: {
        ...mapActions([
            "verifyCodeFVS",
            "verifyCodeFFTR",
            "setSecurityFPTS",
            "setSecurityFSTS"
        ]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            changeAuthVerified: "CHANGE_AUTH_VERIFIED"
        }),
        choseVType() {
            if (this.pageLoading) {
                return;
            }
            this.dialogVisible = true;
        },
        showEditAreaCodeSheet() {
            if (!this.isAreaCodeCanEdit || this.sending) {
                return;
            }
            this.bottomSheetVisible = true;
        },
        selectCode(code) {
            this.aCode = code;
            this.bottomSheetVisible = false;
            this.$refs.form.validate();
        },
        next() {
            let params = {
                type: "mobile",
                mobile: this.fullPhoneNumber,
                mobile_code: this.vCode
            };
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            this.action(params)
                .then(() => {
                    this.isCountDownStop = true;
                    if (this.isVerification) {
                        this.changeAuthVerified("mobile");
                        this.$router.push({
                            name: this.$route.query.redirect,
                            query: Object.assign({}, this.params, {
                                t: Date.now()
                            })
                        });
                    } else {
                        this.alertVisible = true;
                        this.alertType = "success";
                    }
                })
                .catch(err => {
                    if (err.code === 1001) {
                        this.isErrCode = true;
                    } else if (err.code === 1002) {
                        this.isErrValue = true;
                    } else if (err.code === 1003) {
                        this.alertVisible = true;
                        this.alertType = "error";
                    }
                    setTimeout(() => {
                        this.changePageLoading(false);
                        this.$refs.form.validate();
                    }, 300);
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.form.reset();
        next();
    },
    created() {
        this.aCode =
            defaultAreaCodes[this.params.language] || defaultAreaCodes.en;
    }
};
</script>
<style lang="scss">
.form-phone {
    .input-phone-number {
        .v-input__prepend-outer {
            margin: 0 !important;
        }
    }
}
.phone-bottom-card {
    max-height: 60vh;
    overflow: auto;
    .v-list {
        padding-left: constant(safe-area-inset-left);
        padding-left: env(safe-area-inset-left);
        padding-right: constant(safe-area-inset-right);
        padding-right: env(safe-area-inset-right);
    }
}
</style>
